// @ts-strict-ignore
import { ProjectGroupVO } from '@project/model/vo/project-group.vo';
import { cloneDeep } from 'lodash';
import { ProjectHeadVO } from '@project/model/vo/project.vo';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { FriendSharedInfo } from '@project/components/permissions/friend-shared-info';
import { UserFriendListContentPresenter } from './user-friend-list-content.presenter';

export class PermissionsNavigationModel {

  public static readonly ROOT_NAME: string = `projectNavigation.my_projects`;
  public static readonly ROOT_ID: number = -999;

  navigationChain: ProjectGroupVO[]; // data for breadcrumbs

  rootProjectGroup: ProjectGroupVO; // all data
  rootSearchProjectGroup: ProjectGroupVO; // all found data

  currentSelectedItem: ProjectHeadVO | ProjectGroupVO;

  private _currentProjectGroup: ProjectGroupVO = null; // data to render, contains deep copy of latest element in breadcrumbs with filtered result

  currentChanged = new BehaviorSubject<ProjectGroupVO>(this._currentProjectGroup);

  collapsedProjects: number[] = [];

  searchMode: boolean;
  searchText: string;

  canUndo: boolean;
  canRedo: boolean;

  selectAllReadCheckBox: boolean;
  selectAllEditCheckBox: boolean;

  private _friendListContentPresenter: UserFriendListContentPresenter;

  get currentProjectGroup(): ProjectGroupVO {
    return this._currentProjectGroup;
  }

  set currentProjectGroup(value: ProjectGroupVO) {
    const group = cloneDeep(value);
    this._currentProjectGroup = group;
    this.currentSelectedItem = null;
    this.collapsedProjects = [];
    this.currentChanged.next(group);
  }

  public set friendListContentPresenter(friendListContentPresenter: UserFriendListContentPresenter) {
    this._friendListContentPresenter = friendListContentPresenter;
  }

  public get userFriends(): FriendSharedInfo[] {
    return this._friendListContentPresenter ? this._friendListContentPresenter.userFriends : [];
  }

  public get submitEnabled(): boolean {
    return this._friendListContentPresenter ? this._friendListContentPresenter.isUserRightsChanged() : false;
  }
}
